import * as React from 'react';
import * as intl from 'react-intl-universal';
import { Link } from 'react-router-dom';
import { Menu } from 'antd';
import { visualRoutes } from './utils';
import { MetaRoute, Routes } from '../type';
import { languages } from 'common/i18n';
interface iConfig {
    roleType: 'Admin' | 'Client' | 'Sales';
    routes: Routes;
    activeKeys: Array<string>;
}

export default (config: iConfig) => {
    const { routes, activeKeys, roleType } = config;
    const getHref: Function = (route: MetaRoute, index: number) => {
        if (route.children.length && index < 2) {
            return getHref(route.children[0], index + 1);
        } else {
            return route.href;
        }
    };

    return (
        <Menu
            className={`Launcher-menu-header ${languages.getDefault() === 'vi-VN' || languages.getDefault() === 'ja-JP' ? 'small-menu' : null}`}
            mode="horizontal" selectedKeys={activeKeys}>
            {visualRoutes(routes)
                .map((route: MetaRoute) => {
                    const text = intl.get(`Menu.${roleType}${route.key}`);
                    // 格式化href
                    const url = getHref(route, 0);
                    return text && (
                        <Menu.Item key={route.key}
                            className={languages.getDefault() === 'en-US' ? 'ant-menu-item-en' : null}>
                            <Link to={url}>{text}</Link>
                        </Menu.Item>
                    );
                }).filter(item => !!item)}
        </Menu>
    );
};
